module.exports = __webpack_public_path__ + "assets/img/projects_item10.7a9ac4d0.png";